module.exports = __webpack_public_path__ + "img/vk.0a65eec.png";